import React, {PropTypes} from 'react';
import AnswerRow from './AnswerRow';

const AnswerList = ({
  question,
  questionVotes,
  user,
  widgetType,
}) => {
  const answersLength = question.answers.length;
  const answerList = question.answers.map((answer, key) => {
    const answerVotes = questionVotes.answers && questionVotes.answers.filter((item) => item.answer_id === answer.id);
    const answerVote = answerVotes && answerVotes.length === 1 ? answerVotes[0] : null;
    return (
      <AnswerRow
        answer={answer}
        question={question}
        answerVote={answerVote}
        questionUserId={question.user_id}
        user={user}
        key={key}
        lastItem={key === answersLength - 1}
      />
    );
  });

  const hasAnswers = question.answers.length;
  const pluralize = (word) => (hasAnswers === 1 ? word : `${word}s`);
  const typeCopy = widgetType === 'comment' ? pluralize('comment') : pluralize('answer');
  const answerCountCopy = hasAnswers ? `${question.answers.length} ${typeCopy}` : null;

  return (
    <div>
      { hasAnswers ?
        <div>
          <h1 className="heading heading--bold margin-bottom-ml t-answer-count">
            {answerCountCopy}
          </h1>
          <div className="t-answer-list">
            {answerList}
          </div>
        </div>
        : null }
    </div>
  );
};

AnswerList.propTypes = {
  question: PropTypes.object.isRequired,
  user: PropTypes.object,
  questionVotes: PropTypes.object,
  widgetType: PropTypes.string,
};

export default AnswerList;
